import React from 'react'
import { BiSearch } from 'react-icons/bi';


const BigInput1 = (props) => {

	const {
		type,
		name,
		value,
		id,
		placeholder,
		classe,
		required,
		handleChange
	} = props

	return(
		<input 
			type={type} 
			name={name} 
			id={id}
			value={value}
			placeholder={placeholder}
			onChange={handleChange}
			required = {required}
			className={`bg-custom-gray rounded-full w-full py-5 px-3 py-2 md:py-5 text-gray-500 text-xs md:text-sm focus:outline-none text-sm md:text-base font-nunito`}
			/>
	)
}

export default BigInput1